module.exports=window.jQuery;